



import { Component, Mixins } from 'vue-property-decorator';
import mixins from '../mixins';
@Component
export default class FitCheckbox extends Mixins(mixins) {
}
